import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { readFromEnv } from "@cinch-nx/environments";
import { z } from "zod";
import { tagError, setTag, traceFunction } from "@core/datadog-server";
var Review = z.object({
    starRating: z.number(),
    title: z.string(),
    description: z.string(),
    customerName: z.string(),
    date: z.string().datetime(),
    link: z.string().url()
});
var TrustpilotReviewsResponse = z.object({
    trustScore: z.number(),
    stars: z.number(),
    total: z.number(),
    starRatingLabel: z.string(),
    reviews: z.array(Review).min(3).max(3)
});
var fallbackResponse = {
    trustScore: 4.4,
    total: 20000,
    stars: 4.5,
    starRatingLabel: "Excellent",
    reviews: [
        {
            starRating: 5,
            title: "Really good experience",
            description: "Simple to navigate website, with good selection of cars and great part-exchange value.",
            customerName: "Tom Willoughby",
            date: "6 August 2021",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        },
        {
            starRating: 5,
            title: "Excellent service",
            description: "We bought a new car and also part exchanged our old one and the whole process was smooth and efficient.",
            customerName: "Ms Martin",
            date: "8 September 2021",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        },
        {
            starRating: 5,
            title: "So easy from start to finish",
            description: "Can't quite believe that I bought and part exchanged my car in less than a week with absolute ease.",
            customerName: "Kim W",
            date: "23 August 2021",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        }, 
    ]
};
function getTrustpilotReviewsFn() {
    return _getTrustpilotReviewsFn.apply(this, arguments);
}
function _getTrustpilotReviewsFn() {
    _getTrustpilotReviewsFn = _async_to_generator(function() {
        var url, response, ref, _, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    url = "".concat(readFromEnv("TRUSTPILOT_URL"), "/trustpilot-get-reviews");
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    response = _state.sent();
                    setTag("request.url", url);
                    setTag("request.method", "GET");
                    setTag("request.status", response.status);
                    setTag("request.content-length", (ref = response.headers.get("content-length")) !== null && ref !== void 0 ? ref : "0");
                    _ = TrustpilotReviewsResponse.parse;
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _.apply(TrustpilotReviewsResponse, [
                            _state.sent()
                        ])
                    ];
                case 3:
                    error = _state.sent();
                    if (typeof error === "string" || _instanceof(error, Error)) {
                        tagError(error);
                    }
                    console.error(error);
                    return [
                        2,
                        fallbackResponse
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getTrustpilotReviewsFn.apply(this, arguments);
}
export var getTrustpilotReviews = traceFunction("trustpilot.getTrustpilotReviews", getTrustpilotReviewsFn);
